import Stripe from './Stripe';
export default Stripe;